import type { IBankAccount } from "../types";

// @TODO Zbavit se této entity
export default class SenderBankAccount implements IBankAccount {
  bank?: string;
  accountNumber: string;
}
